// extracted by mini-css-extract-plugin
module.exports = {"container":"NoteRanges_container__viLQL","headerContainer":"NoteRanges_headerContainer__t3h7p"};